import { useSelector } from 'react-redux';
import { CA, US } from '../../constants/country-codes';
import { ENDICIA_FIRSTCLASSINTERNATIONAL_SERVICE_ID, STAMPS_FIRSTCLASSINTERNATIONAL_SERVICE_ID } from '../../constants/services';
import { Providers } from '../../enums/providers';
import { useShipFrom } from '../../hooks/ship-froms/use-ship-from';
import Global from '../../store/global-selectors';
import { useFulfillmentPlannerContext } from '../../fulfillment-planner/context';

const useDetermineSourceValues = (fulfillmentPlanId) => {
  const entitiesFp = useSelector((state) => Global.selectEntitiesFulfillmentPlanById(state, { fulfillmentPlanId })) || {};
  const { fulfillmentPlanId: contextFpId, shipTo, shipFromId, serviceIdAndSellerLabelProviderId } = useFulfillmentPlannerContext();

  // favor context for responsiveness, but if component is being used in bulk update we need entity
  // because there is no context
  if (fulfillmentPlanId === contextFpId) {
    return {
      shipTo,
      shipFromId,
      serviceId: serviceIdAndSellerLabelProviderId?.serviceId,
      sellerLabelProviderId: serviceIdAndSellerLabelProviderId?.sellerLabelProviderId,
    };
  }
  return {
    shipTo: entitiesFp.shipTo,
    shipFromId: entitiesFp.shipFromId,
    serviceId: entitiesFp.serviceId,
    sellerLabelProviderId: entitiesFp.sellerLabelProviderId,
  };
};

export const useShouldShowDdp = (fulfillmentPlanId) => {
  const { shipTo, shipFromId, serviceId, sellerLabelProviderId } = useDetermineSourceValues(fulfillmentPlanId);

  const selectedShipFrom = useShipFrom(shipFromId);
  const shipToCountryCode = shipTo?.countryCode;
  const includesServiceId =
    serviceId === STAMPS_FIRSTCLASSINTERNATIONAL_SERVICE_ID || serviceId === ENDICIA_FIRSTCLASSINTERNATIONAL_SERVICE_ID;
  const correctShippingDirection = selectedShipFrom?.countryCode === US && shipToCountryCode === CA;
  const labelProviders = useSelector(Global.selectSellerLabelProviders);
  const labelProviderId = labelProviders.find((p) => p.sellerLabelProviderId === sellerLabelProviderId)?.labelProviderId;
  const isStampsOrEndicia = labelProviderId === Providers.Stamps.labelProviderId || labelProviderId === Providers.Endicia.labelProviderId;

  const invalidInfo = !fulfillmentPlanId || !shipFromId || !shipTo || !serviceId || !sellerLabelProviderId;
  const shouldShowDdp = invalidInfo || !isStampsOrEndicia || (includesServiceId && correctShippingDirection);

  return shouldShowDdp;
};
